import { BCNotification, findMessage } from '@bimser/components';
export function nullItemAlert(nullItemName: string) {
	BCNotification.warning({
		description: findMessage.get('101340') + nullItemName,
		message: findMessage.get('101356')
	});
}
